import type React from 'react';

import { SearchClientProvider } from '#src/app/pages/search/shared/hooks';

import { MaintenanceContainer } from '../components/MaintenanceContainer';
import { PageBody } from '../components/PageBody';

import { useLayout } from './hooks/useLayout';
import { useTrackPageView } from './hooks/useTrackPageView';
import { useUnderMaintenance } from './hooks/useUnderMaintenance';

const LayoutInner: React.FC<EmptyProps> = () => {
	const {
		data: { typesenseClient, collectionName, preset },
	} = useLayout();

	return (
		<SearchClientProvider typesenseClient={typesenseClient} collectionName={collectionName} preset={preset}>
			<PageBody />
		</SearchClientProvider>
	);
};

export const Layout: React.FC<EmptyProps> = () => {
	useTrackPageView();

	const {
		data: { isUnderMaintenance },
	} = useUnderMaintenance();

	if (isUnderMaintenance) {
		return <MaintenanceContainer />;
	}

	return <LayoutInner />;
};
